import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const externalLinks = [
  { label: "yoybuy sheet", url: "https://kaspreadsheet.com" },
  { label: "buy it now", url: "https://kaspreadsheet.com" },
];

const internalLinks = [
  { label: "Главная", path: "/" },
  { label: "Статья", path: "/article" },
];

const comparisonLinks = [
  { label: "YOYBUY vs KAKOBUY", path: "/yoybuy-vs-kakobuy" },
  { label: "YOYBUY vs SUPERBUY", path: "/yoybuy-vs-superbuy" },
  { label: "KAKOBUY vs SUPERBUY", path: "/kakobuy-vs-superbuy" },
  { label: "Альтернатива SUPERBUY", path: "/superbuy-alternative" },
  { label: "FAQ", path: "/faq" },
];

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [compareOpen, setCompareOpen] = useState(false);
  const compareRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (compareRef.current && !compareRef.current.contains(e.target as Node)) {
        setCompareOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCompareOpen(false);
  }, [location.pathname]);

  const LogoTag = isHome ? "h1" : "div";
  const navTextColor = !isHome || scrolled ? "text-foreground-950" : "text-white";
  const navBg = !isHome || scrolled
    ? "bg-white border-b border-background-200"
    : "bg-transparent";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${navBg}`}
    >
      <div className="w-full px-4 md:px-8 py-4 flex items-center justify-between">
        <LogoTag className={`text-xl font-bold font-heading ${navTextColor}`}>
          <a href="/" className="hover:opacity-80 transition-opacity">
            YOYBUY Spreadsheet
          </a>
        </LogoTag>

        <nav className="hidden md:flex items-center gap-6">
          {internalLinks.map((link) => (
            <a
              key={link.path}
              href={link.path}
              className={`text-sm font-medium hover:text-primary-500 transition-colors ${navTextColor}`}
            >
              {link.label}
            </a>
          ))}

          <div className="relative" ref={compareRef}>
            <button
              onClick={() => setCompareOpen(!compareOpen)}
              className={`text-sm font-medium hover:text-primary-500 transition-colors flex items-center gap-1 cursor-pointer ${navTextColor}`}
            >
              Сравнения
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`ri-arrow-down-s-line text-sm transition-transform ${compareOpen ? "rotate-180" : ""}`} />
              </div>
            </button>
            {compareOpen && (
              <div className="absolute top-full left-0 mt-2 bg-white border border-background-200 rounded-lg shadow-lg py-2 min-w-[220px]">
                {comparisonLinks.map((link) => (
                  <a
                    key={link.path}
                    href={link.path}
                    className="block px-4 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            )}
          </div>

          {externalLinks.map((link) => (
            <a
              key={link.label}
              href={link.url}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 px-4 py-2 rounded-md whitespace-nowrap transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          className={`md:hidden p-2 ${navTextColor}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
          </div>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-b border-background-200 px-4 pb-4">
          <div className="flex flex-col gap-3">
            {internalLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                className="text-sm font-medium text-foreground-800 py-2 border-b border-background-100"
              >
                {link.label}
              </a>
            ))}
            <p className="text-sm font-semibold text-foreground-500 pt-1">Сравнения</p>
            {comparisonLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                className="text-sm text-foreground-700 py-1 hover:text-primary-500"
              >
                {link.label}
              </a>
            ))}
            {externalLinks.map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 px-4 py-2 rounded-md whitespace-nowrap text-center transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}